import ButtonBlock from 'components/ButtonBlock';
import CTA from 'components/CTA';
import ContentCarousel from 'components/ContentCarousel';
import FeatureBanner from 'components/FeatureBanner';
import HeadingAndDesc from 'components/HeadingAndDesc';
import IconContent from 'components/IconContent';
import Metadata from 'components/Metadata';
import QABlock from 'components/QABlock';
import Steps from 'components/Steps';
import TwoCols from 'components/TwoCols';
import PropTypes from 'prop-types';
import React from 'react';

const SMSTpl = ({ data }) => {
  const {
    smsPage: {
      title,
      meta: { description, breadcrumb },
      banner,
      twoCols,
      carousel,
      freeTrial,
      threeCols,
      featuresHeading,
      featuresList,
      smsfooter,
      smsQA
    }
  } = data;
  return (
    <div>
      <Metadata title={title} description={description} />
      <FeatureBanner data={banner}  breadcrumb={breadcrumb} />
      <TwoCols data={twoCols} padding="TopM" />
      <ContentCarousel data={carousel} />
      <CTA {...freeTrial} />
      <HeadingAndDesc data={{"heading": `${threeCols.heading}`, "desc": `${threeCols.desc}`}} theme="Grey" size="M" />
      <IconContent data={threeCols.list} theme="Grey" smallIcon={false} wrapper="M" />
      <HeadingAndDesc data={{"heading": `${featuresHeading.heading}`, "desc": `${featuresHeading.desc}`}} theme="Blue" />
      <IconContent data={featuresList} columnCount={4} alignLeft theme="Blue" />
      <ButtonBlock padding="BottomM" theme="Blue" btn={featuresHeading.cta} waveBottom />
      <Steps data={smsfooter} />
      <QABlock data={smsQA.list} />
    </div>
  );
};

SMSTpl.propTypes = {
  data: PropTypes.object,
};

export default SMSTpl;
